import React, { useEffect } from 'react'
import { type StripeElements, type Stripe } from '@stripe/stripe-js'
import { PaymentElement, type PaymentElementProps, useElements, useStripe } from '@stripe/react-stripe-js'

interface Props extends PaymentElementProps {
  setStripeElements: (stripeElements: StripeElements) => void
  setStripeClient: (stripeClient: Stripe) => void
  withoutElements?: boolean
}

export const AblefyStripePaymentElement = (props: Props) => {
  const { setStripeElements, setStripeClient, withoutElements, ...rest } = props
  const elements = useElements()
  const stripe = useStripe()

  useEffect(() => {
    if (elements) {
      setStripeElements(elements)
    }
    if (stripe) {
      setStripeClient(stripe)
    }
  }, [elements, stripe])

  if (withoutElements) {
    return null
  }

  return <PaymentElement {...rest} />
}
